import { Outlet } from 'react-router';

import { AuthGuard } from '@treneo/processes/auth';
import { urls } from '@treneo/shared/constants';
import { useAppLocation } from '@treneo/shared/router';

import { AppLayout } from '../../app-layout';

export const RequireAuth = () => {
  const location = useAppLocation();
  const isAdminRoute = location.pathname.startsWith(urls.adminPanel);

  if (isAdminRoute) {
    return (
      <AuthGuard>
        <Outlet />
      </AuthGuard>
    );
  }

  return (
    <AuthGuard>
      <AppLayout isForLogged>
        <Outlet />
      </AppLayout>
    </AuthGuard>
  );
};
